/* Русские названия направлений по градусам */
function DirectionToText(value) {
  if (value >= 0 && value < 11.25) return "С";
  if (value >= 11.25 && value < 33.75) return "ССВ";
  if (value >= 33.75 && value < 56.25) return "СВ";
  if (value >= 56.25 && value < 78.75) return "ВСВ";
  if (value >= 78.75 && value < 101.25) return "В";
  if (value >= 101.25 && value < 123.75) return "ВЮВ";
  if (value >= 123.75 && value < 146.25) return "ЮВ";
  if (value >= 146.25 && value < 168.75) return "ЮЮВ";
  if (value >= 168.75 && value < 191.25) return "Ю";
  if (value >= 191.25 && value < 213.75) return "ЮЮЗ";
  if (value >= 213.75 && value < 236.25) return "ЮЗ";
  if (value >= 236.25 && value < 258.75) return "ЗЮЗ";
  if (value >= 258.75 && value < 281.25) return "З";
  if (value >= 281.25 && value < 303.75) return "ЗСЗ";
  if (value >= 303.75 && value < 326.25) return "СЗ";
  if (value >= 326.25 && value < 348.75) return "ССЗ";
  if (value >= 348.75) return "С";
}

/* Округление градусов */
function DirectionRound(value) {
  if (value >= 0 && value < 11.25) return 0;
  if (value >= 11.25 && value < 33.75) return 22.5;
  if (value >= 33.75 && value < 56.25) return 45;
  if (value >= 56.25 && value < 78.75) return 67.5;
  if (value >= 78.75 && value < 101.25) return 90;
  if (value >= 101.25 && value < 123.75) return 112.5;
  if (value >= 123.75 && value < 146.25) return 135;
  if (value >= 146.25 && value < 168.75) return 157.5;
  if (value >= 168.75 && value < 191.25) return 180;
  if (value >= 191.25 && value < 213.75) return 202.5;
  if (value >= 213.75 && value < 236.25) return 225;
  if (value >= 236.25 && value < 258.75) return 247.5;
  if (value >= 258.75 && value < 281.25) return 270;
  if (value >= 281.25 && value < 303.75) return 292.5;
  if (value >= 303.75 && value < 326.25) return 315;
  if (value >= 326.25 && value < 348.75) return 337.5;
  if (value >= 348.75) return 0;
}

/* Подсчет направлений */
async function CountDirections(e) {
  const text = ["С", "ССВ", "СВ", "ВСВ", "В", "ВЮВ", "ЮВ", "ЮЮВ", "Ю", "ЮЮЗ", "ЮЗ", "ЗЮЗ", "З", "ЗСЗ", "СЗ", "ССЗ"];
  const direction = [];
  e.forEach((element) => {
    direction.push(DirectionToText(element));
  });
  const counts = direction.reduce(function(acc, el) {
    acc[el] = (acc[el] || 0) + 1;
    return acc;
  }, {});
  const result = [];
  text.forEach((i) => {
    counts[i] ? result.push(counts[i]) : result.push(0);
  });
  return result;
}

export { DirectionToText, DirectionRound, CountDirections };
